<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">

      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            Assign Tasks to Workstation
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <v-form 
          class="modal-card-body" 
          :valid.sync="valid">

          <div class="field">
            <label class="label">
              Workstation*
            </label>

            <v-select 
              required
              :options="workstations"
              item-value="id"
              item-text="workstation_name"
              v-model="workstationId"
            />
          </div>

          <table class="table is-hoverable">
            <thead>
              <th 
                v-for="(header, headerIndex) in headers"
                :key="headerIndex">
                {{ header }}
              </th>
            </thead>

            <tbody>

              <template 
                v-for="taskGroup in stepsSelected">

                <tr
                  class="has-background-light subheader" 
                  :key="taskGroup.id">
                  <td :colspan="headers.length">
                    {{ taskGroup.project.project_name }}
                  </td>
                </tr>

                <tr 
                  class="v-centered"
                  v-for="task in taskGroup.production_steps"
                  :key="task.id">
                  <td>
                    {{ task.step.work_name }}
                  </td>
                  <td>
                    {{ task.exp_duration_min }}
                  </td>
                  <td
                    :class="{ 
                      'has-text-grey-light': task.qty_unassigned - task.qty_assigned == 0 
                    }">
                    {{ task.qty_unassigned - task.qty_assigned }}
                  </td>
                  <td>
                    <v-text-field
                      required
                      type="number"
                      placeholder="Quantity to assign"
                      :value="task.qty_assigned"
                      @input="setQuantityAssigned({
                        masterProductionId: taskGroup.id, 
                        productionStepId: task.id,
                        value: $event
                      })"
                      :rules="[
                        (v) => v <= task.qty_unassigned || 'Quantity assigned cannot be greater than quantity needed' 
                      ]"/>
                  </td>
                </tr>

              </template>

            </tbody>
          </table>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="addTasks()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VSelect from '@/components/base/VSelect'
import VTextField from '@/components/base/VTextField'

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  components: { VForm, VSelect, VTextField },
  props: {
    value: {
      type: Boolean
    }
  },
  data() {
    return {
      workstationId: null,
      headers: [
        'Task', 'Exp. Duration', 'Unassigned Quantity', 'Quantity to Assign'
      ],
      valid: false
    }
  },
  computed: {
    ...mapState("workstations", ["workstations"]),
    ...mapGetters("masterProductions", ["stepsSelected"])
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("workstations", ["getWorkstations"]),
    ...mapActions("masterProductions", ["getMasterProductions"]),
    ...mapActions("workstationQueues", ["addWorkstationTask"]),
    ...mapMutations("masterProductions", [
      "setQuantityAssigned", "deselectAll"
    ]),
    initialize() {
      if (this.workstations.length == 0) {
        this.getWorkstations({ per_page: 1000 });
      }
    },
    addTasks() {
      let allTasks = this.stepsSelected.map(
        d => d.production_steps
      ).flat(1).map(d => { 
        return {
          master_production_step_id: d.id,
          qty_assigned: d.qty_assigned,
          workstation_id: this.workstationId
        }
      });
      
      let promises = [];

      allTasks.forEach(task => {
        promises.push(
          this.addWorkstationTask(task)
        )
      })

      Promise.all(promises).then(() => {
        this.getMasterProductions();
        this.deselectAll();
        this.close(true);
      });
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>